import { createAsyncAction } from "typesafe-actions";

import { AuthActionTypes } from "./types";
import { ILoginRequest, ILoginResponse } from "app/services/default";

export const loginAsync = createAsyncAction(
    AuthActionTypes.GET_LOGIN_REQUEST,
    AuthActionTypes.GET_LOGIN_SUCCESS,
    AuthActionTypes.GET_LOGIN_FAILTURE
)<ILoginRequest, ILoginResponse, any>();
